export const FETCH_POSTS = 'postActions/FETCH_POSTS';
export const FETCH_POSTS_SUCCESS = 'postActions/FETCH_POSTS_SUCCESS';
export const FETCH_POSTS_FAILED = 'postActions/FETCH_POSTS_FAILURE';

export const CREATE_POST = 'postActions/CREATE_POST';
export const CREATE_POST_SUCCESS = 'postActions/CREATE_POST_SUCCESS';
export const CREATE_POST_FAILED = 'postActions/CREATE_POST_FAILURE';

export const UPDATE_POST = 'postActions/UPDATE_POST';
export const UPDATE_POST_SUCCESS = 'postActions/UPDATE_POST_SUCCESS';
export const UPDATE_POST_FAILED = 'postActions/UPDATE_POST_FAILURE';

export const DELETE_POST = 'postActions/DELETE_POST';
export const DELETE_POST_SUCCESS = 'postActions/DELETE_POST_SUCCESS';
export const DELETE_POST_FAILED = 'postActions/DELETE_POST_FAILURE';

export const UPDATE_STATE = 'postActions/UPDATE_STATE';
export const UPDATE_EDIT = 'postActions/UPDATE_EDIT';
export const FETCH_POST = 'postActions/FETCH_POST';
export const FETCH_POST_SUCCESS = 'postActions/FETCH_POST_SUCCESS';
export const FETCH_POST_FAILED = 'postActions/FETCH_POST_FAILURE';

export const FETCH_POST_GALLERY = 'postActions/FETCH_POST_GALLERY';
export const FETCH_POST_GALLERY_SUCCESS =
  'postActions/FETCH_POST_GALLERY_SUCCESS';
export const FETCH_POST_GALLERY_FAILED =
  'postActions/FETCH_POST_GALLERY_FAILURE';

export const ADD_IMAGE = 'postActions/ADD_IMAGE';
export const COPY_MOVE_POST = 'postActions/COPY_MOVE_POST';
export const COPY_MOVE_POST_SUCCESS = 'postActions/COPY_MOVE_POST_SUCCESS';
export const COPY_MOVE_POST_FAILED = 'postActions/COPY_MOVE_POST_FAILED';

export const FETCH_WEEKLY = 'postActions/FETCH_WEEKLY';
export const FETCH_WEEKLY_SUCCESS = 'postActions/FETCH_WEEKLY_SUCCESS';
export const FETCH_WEEKLY_FAILED = 'postActions/FETCH_WEEKLY_FAILURE';

export const UNLINK_FOLDER = 'postActions/UNLINK_FOLDER';
export const UNLINK_FOLDER_SUCCESS = 'postActions/UNLINK_FOLDER_SUCCESS';
export const UNLINK_FOLDER_FAILED = 'postActions/ UNLINK_FOLDER_FAILURE';

export const CONNECT_FOLDER = 'postActions/CONNECT_FOLDER';
export const CONNECT_FOLDER_SUCCESS = 'postActions/CONNECT_FOLDER_SUCCESS';
export const CONNECT_FOLDER_FAILED = 'postActions/ CONNECT_FOLDER_FAILURE';

export const FETCH_FOLDER = 'postActions/FETCH_FOLDER';
export const FETCH_FOLDER_SUCCESS = 'postActions/FETCH_FOLDER_SUCCESS';
export const FETCH_FOLDER_FAILED = 'postActions/ FETCH_FOLDER_FAILURE';

export const FETCH_FOLDERS = 'postActions/FETCH_FOLDERS';
export const FETCH_FOLDERS_SUCCESS = 'postActions/FETCH_FOLDERS_SUCCESS';
export const FETCH_FOLDERS_FAILED = 'postActions/ FETCH_FOLDERS_FAILURE';

export const SEND_TO = 'postActions/SEND_TO';
export const SEND_TO_SUCCESS = 'postActions/SEND_TO_SUCCESS';
export const SEND_TO_FAILED = 'postActions/ SEND_TO_FAILURE';
export const CLEAR_POST = 'postActions/CLEAR_POST';
export const ADD_FILE_SUCCESS = 'fileActions/ADD_FILE_SUCCESS';

export function fetchPosts(pageFolderId, filters, silent = false) {
  return {
    type: FETCH_POSTS,
    filters,
    pageFolderId,
    silent,
  };
}

export function fetchPostsSuccess(posts, statuses, total, pageNumberBack) {
  posts.reverse();
  return {
    type: FETCH_POSTS_SUCCESS,
    posts,
    statuses,
    total,
    pageNumberBack,
  };
}

export function fetchPostsFailed(err) {
  return {
    type: FETCH_POSTS_FAILED,
    err,
  };
}

export function createPost(details) {
  return {
    type: CREATE_POST,
    details,
  };
}

export function createPostSuccess(post) {
  return {
    type: CREATE_POST_SUCCESS,
    post,
  };
}

export function createPostFailed(err) {
  return {
    type: CREATE_POST_FAILED,
    err,
  };
}

export function updatePost(id, details, single) {
  return {
    type: UPDATE_POST,
    details,
    id,
    single,
  };
}

export function updatePostSuccess(post, postId) {
  return {
    type: UPDATE_POST_SUCCESS,
    post,
    postId,
  };
}

export function updatePostFailed(err) {
  return {
    type: UPDATE_POST_FAILED,
    err,
  };
}

export function deletePost(id) {
  return {
    type: DELETE_POST,
    id,
  };
}

export function deletePostSuccess(posts) {
  return {
    type: DELETE_POST_SUCCESS,
    posts,
  };
}

export function deletePostFailed(err) {
  return {
    type: DELETE_POST_FAILED,
    err,
  };
}

export function updateState() {
  return {
    type: UPDATE_STATE,
  };
}

export function fetchPostById(id) {
  return {
    type: FETCH_POST,
    id,
  };
}

export function fetchPostByIdSuccess(post) {
  return {
    type: FETCH_POST_SUCCESS,
    post,
  };
}

export function fetchPostByIdFailed(err) {
  return {
    type: FETCH_POST_FAILED,
    err,
  };
}

export function fetchPostByIdWithRevisionId(id, revisionId) {
  return {
    type: FETCH_POST,
    id,
    revisionId,
  };
}

export function fetchPostByIdWithRevisionIdSuccess(post) {
  return {
    type: FETCH_POST_SUCCESS,
    post,
  };
}

export function fetchPostByIdWithRevisionIdFailed(err) {
  return {
    type: FETCH_POST_FAILED,
    err,
  };
}

export function restorePostWithRevisionId(id, revisionId) {
  return {
    type: UPDATE_POST,
    id,
    revisionId,
  };
}

export function restorePostWithRevisionIdSuccess(post) {
  return {
    type: UPDATE_POST_SUCCESS,
    post,
  };
}

export function restorePostWithRevisionIdFailed(err) {
  return {
    type: UPDATE_POST_FAILED,
    err,
  };
}

export function fetchPostGallery(id) {
  return {
    type: FETCH_POST_GALLERY,
    id,
  };
}

export function fetchPostGallerySuccess(folders, extraFolders) {
  return {
    type: FETCH_POST_GALLERY_SUCCESS,
    folders,
    extraFolders,
  };
}

export function fetchPostGalleryFailed(err) {
  return {
    type: FETCH_POST_GALLERY_FAILED,
    err,
  };
}

export function addImage(image) {
  return {
    type: ADD_IMAGE,
    image,
  };
}

export function copyMove(details, isCopy, id, pageFolderId) {
  return {
    type: COPY_MOVE_POST,
    details,
    isCopy,
    id,
    pageFolderId,
  };
}

export function copyMoveSuccess(isCopy, post, id) {
  return {
    type: COPY_MOVE_POST_SUCCESS,
    post,
    isCopy,
    id,
  };
}

export function copyMoveFailed(post, isCopy, id) {
  return {
    type: COPY_MOVE_POST_FAILED,
    isCopy,
    post,
    id,
  };
}

export function fetchWeekly() {
  return {
    type: FETCH_WEEKLY,
  };
}

export function fetchWeeklySuccess(posts) {
  return {
    type: FETCH_WEEKLY_SUCCESS,
    posts,
  };
}

export function fetchWeeklyFailed(err) {
  return {
    type: FETCH_WEEKLY_FAILED,
    err,
  };
}

export function unlinkFolder(postId, folderId) {
  return {
    type: UNLINK_FOLDER,
    postId,
    folderId,
  };
}

export function unlinkFolderSuccess(posts) {
  return {
    type: UNLINK_FOLDER_SUCCESS,
    posts,
  };
}

export function unlinkFolderFailed(err) {
  return {
    type: UNLINK_FOLDER_FAILED,
    err,
  };
}

export function connectFolder(postId, companyId) {
  return {
    type: CONNECT_FOLDER,
    postId,
    companyId,
  };
}

export function connectFolderSuccess(posts) {
  return {
    type: CONNECT_FOLDER_SUCCESS,
    posts,
  };
}

export function connectFolderFailed(err) {
  return {
    type: CONNECT_FOLDER_FAILED,
    err,
  };
}

export function sendToGallery(postId, folderId) {
  return {
    type: SEND_TO,
    postId,
    folderId,
  };
}

export function sendToGallerySuccess(posts) {
  return {
    type: SEND_TO_SUCCESS,
    posts,
  };
}

export function sendToGalleryFailed(err) {
  return {
    type: SEND_TO_FAILED,
    err,
  };
}

export function fetchFolders(filters) {
  return {
    type: FETCH_FOLDERS,
    filters,
  };
}

export function fetchFoldersSuccess(folders, total, folder, path) {
  return {
    type: FETCH_FOLDERS_SUCCESS,
    folders,
    total,
    folder,
    path,
  };
}

export function fetchFoldersFailed(err) {
  return {
    type: FETCH_FOLDERS_FAILED,
    err,
  };
}

export function fetchFolder(folderId) {
  return {
    type: FETCH_FOLDER,
    folderId,
  };
}

export function fetchFolderSuccess(folder) {
  return {
    type: FETCH_FOLDER_SUCCESS,
    folder,
  };
}

export function fetchFolderFailed(err) {
  return {
    type: FETCH_FOLDER_FAILED,
    err,
  };
}

export function addUploadedFile(file) {
  return {
    type: ADD_FILE_SUCCESS,
    file,
  };
}

export function updateEdit(details) {
  return {
    type: UPDATE_EDIT,
    details,
  };
}

export function copyMoveOnce(details, isCopy, id, pageFolderId) {
  return {
    type: COPY_MOVE_POST,
    details,
    isCopy,
    id,
    pageFolderId,
  };
}

export function clearPost() {
  return {
    type: CLEAR_POST,
  };
}
